import { render } from "./ModalCambiarPasswordError.vue?vue&type=template&id=0c9b9a9e&scoped=true"
import script from "./ModalCambiarPasswordError.vue?vue&type=script&lang=js"
export * from "./ModalCambiarPasswordError.vue?vue&type=script&lang=js"

import "./ModalCambiarPasswordError.vue?vue&type=style&index=0&id=0c9b9a9e&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9b9a9e"]])

export default __exports__